import { Component, ElementRef, Input, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { CaptchaComponent } from '@appNeo/neoShared/components/captcha/captcha.component';
import { NotificacionComponent } from '@appNeo/neoShared/components/notificacion/notificacion.component';
import { IconEnum } from '@appNeo/neoShared/helpers/enums/Icon.enum';
import { NotificacionEnum } from '@appNeo/neoShared/helpers/enums/Notificacion.enum';
import { ValidatorHelper } from '@appNeo/neoShared/helpers/validators/validator.helper';
import { AuxiliarService } from '@appNeo/neoShared/services/auxiliar/auxiliar.service';
import { EmailContactoService } from '@appNeo/neoShared/services/email-contacto/email-contacto.service';
import { tr } from 'date-fns/locale';
import { debounceTime, distinctUntilChanged, first, fromEvent, Subscription, switchMap, tap } from 'rxjs';

@Component({
  selector: 'neo-formulario-contacto-front',
  templateUrl: './formulario-contacto-front.component.html',
  styleUrls: ['./formulario-contacto-front.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class FormularioContactoFrontComponent implements OnInit {


  minCaracteres: number = 10;
  maxCaracteres: number = 12;
  hide = true;
  formValidators: FormGroup;
  valoresIniciales = {};
  formValueReset = true;
  error = '';
  // criterioValidez = true;
  // barraFortaleza = false;
  @Input() solicitarCaptcha: boolean = true;
  @Input() linkPolitica: string = '/auth/registro';

  @Input() class: string = ''

  @ViewChild('notificacion') notificacion: NotificacionComponent;
  @ViewChild('formElement') formElement: ElementRef;
  @ViewChild('captcha') captcha: CaptchaComponent;

  submitted = false;
  registerInvalidMessage = 'Ha ocurrido un error en el registro';

  subFormulario: Subscription;


  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    // private authService: AuthService,
    private emailContactoService: EmailContactoService,
    private auxiliarService: AuxiliarService,
    private validatorHelper: ValidatorHelper
  ) { }

  ngOnInit(): void {
    this.buildForm();

  }

  ngOnDestroy(): void {
  }

  ngAfterViewInit(): void {
    this.subscripcionFormulario();
  }

  subscripcionFormulario() {
    this.subFormulario = this.formValidators.valueChanges
      .pipe(
        debounceTime(500),
        distinctUntilChanged((formEntityOld, formEntityNew) => JSON.stringify(formEntityOld) === JSON.stringify(formEntityNew)),
        switchMap(formEvent => {
          return fromEvent(this.formElement.nativeElement, 'submit')
            .pipe(
              first(),
            );
        })
      )
      .subscribe(this.enviarContacto.bind(this));
  }


  buildForm(): void {
    this.formValidators = this.formBuilder.group({
      nombre: ['', Validators.required],
      telefono: ['', Validators.required],
      email: ['', [Validators.required, Validators.pattern(this.auxiliarService.patternEmail())]],
      captcha: [''],
      mensaje: ['', Validators.required],
      politica_privacidad: [false, Validators.requiredTrue],
      comunicacionesComerciales: [false],
    });
    if (this.solicitarCaptcha) {
      this.formValidators.controls.captcha.setValidators(Validators.required);
    }
  }

  enviarContacto() {
    let validacionCaptcha = (this.solicitarCaptcha) ? this.captcha.captchaValidator() : true;
    this.formValidators.get('politica_privacidad').markAsDirty();
    if (this.formValidators.valid && validacionCaptcha) {

      this.notificacion.eliminarNotificaciones();
      let peticion = { ...this.formValidators.value };
      delete peticion?.politica_privacidad;
      delete peticion?.captcha;
      if (!peticion?.comunicacionesComerciales) {
        peticion['comunicacionesComerciales'] = false;
      }
      this.submitted = true;
      this.emailContactoService.enviar(peticion).subscribe(
        x => {
          // this.subFormulario.unsubscribe();
          this.showResult('Solicitud de contacto enviada con éxito.', 'ok')
          this.reset();
        },
        e => {
          let aviso = (typeof e?.mensaje === 'string') ? e.mensaje : '';
          this.showResult('Se ha producido un error al enviar la solicitud ' + aviso, 'ko')
        }
      );
    }
  }

  private reset() {
    // if (this.camposTelefono) this.resetCamposTelefono(valoresForm);
    // this.formValidators.reset();
    // this.subscripcionFormulario();
    for (var name in this.formValidators.controls) {
      (<FormControl>this.formValidators.controls[name]).setValue(undefined);
      this.formValidators.controls[name].setErrors(null);
    }
    this.captcha.generateCaptcha();
  }
  showResult(message: string, status: string) {
    this.submitted = false;
    if (this.notificacion) this.notificacion.eliminarNotificaciones();
    if (status == 'ok') {
      this.notificacion.crearNotificacion(NotificacionEnum.Exito, '', message, true, IconEnum.Exito, '');
    } else {
      this.notificacion.crearNotificacion(NotificacionEnum.Error, '', message, true, IconEnum.Error);
    }
  }


}

